import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Accounts'

export const AccountsEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetUserAccounts")
]